module.exports = __webpack_public_path__ + "static/Logo Circle-d136fad9bfb050efed1f07ddb05fa8e5.png";